module.exports = __webpack_public_path__ + "static/media/reactjs.4dc1b755.svg";